import { Col, Row } from "react-bootstrap";
import { IDataPointDTO } from "../../../../../shared/oversight-core/dtos/response-dtos/data-point-dto";
import styles from "./live-meter-component.module.scss";

interface IProps {
  latestMeterSnapshot: IDataPointDTO;
}

const LiveMeterComponent = ({ latestMeterSnapshot }: IProps) => {
  const getValueColor = () => {
    switch (latestMeterSnapshot.category) {
      // case "voltage":
      //   return "#2f2a89";
      // case "current":
      //   return "#FFA500";
      // case "power":
      //   return "#FF8C00";
      // case "powerFactor":
      //   return "#FF6347";
      // case "Current":
      //   return "#FF4500";
      // case "frequency":
      //   return "#FF0000";
      // case "status":
      //   return "#FF0000";
      // case "energy":
      //   return "#FF0000";
      default:
        return "#383941";
    }
  };
  return (
    <div
      className={`${styles.liveMeterComponentContainer} border border-gray-200 rounded-3 py-2 px-3 h-100`}
    >
      <Row>
        <Col className="text-light font-weight-400 font-size-14">
          {latestMeterSnapshot.name}
        </Col>
      </Row>
      <Row>
        <Col
          className="font-weight-600 font-size-16"
          style={{ color: getValueColor() }}
        >
          {latestMeterSnapshot.value}
        </Col>
      </Row>
      <Row>
        <Col className="text-light font-weight-400 font-size-14">
          {latestMeterSnapshot.unit}
        </Col>
      </Row>
    </div>
  );
};

export default LiveMeterComponent;
